"use client";
import dynamic from "next/dynamic";
/**
 * This is a dynamic import of the Map component.
 * The JS bundle for this component will only be downloaded in the browser when
 * the component is rendered instead of being bundled with the rest of the app.
 */
export const DynamicMap = dynamic(() => import("@/components/mapbox/map"));
